module.exports = __webpack_public_path__ + "static/media/h4i-logo.53d2f678.svg";